import { Row, Col, Input, Select, Form } from "antd";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import cdsLogo from "assets/img/cds_logo.jpg";

interface PlotProviderProps {
  plotProviders: API_PrintJobProvider[];
}

export const PlotProvider = observer(({ plotProviders }: PlotProviderProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  return (
    <Row justify="start" align="middle" gutter={24}>
      <Col span={12}>
        <Form.Item
          label={t("Order will be executed by")}
          name="providerId"
          initialValue={plotProviders[0] && plotProviders[0].id}
        >
          <Select>
            {plotProviders.slice().map(({ id, name }) => {
              // custom view for CDS provider
              if (id === 0) {
                return (
                  <Select.Option key={name} value={id}>
                    <img src={cdsLogo} alt="CDS logo" className="mr-5" style={{ width: 35 }} />
                    {t(name)}
                  </Select.Option>
                );
              }
              return (
                <Select.Option key={name} value={id}>
                  {t(name)}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={23}>
        <Form.Item label={t("Remark")} name="remark" initialValue={""}>
          <Input.TextArea
            placeholder={t("Write your remark here")}
            style={{ padding: 10, border: "1px solid #e0e5ed" }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
});
